import { useState } from "react"
import Head from "next/head"
import styled from "styled-components"

import useMapbox from "lib/useMap"

import MapModal from "components/MapModal"
import { breakpoint } from "styles/Variables"

const MapLauncher = styled.button.attrs(() => ({
  ariaLabel: "Open Bunuba Country Map",
}))`
  width: 85px;
  height: 85px;
  border: 3px solid white;
  border-radius: 80px;
  box-shadow: 0px 2px 5px rgba(0, 0, 0, 0.1);
  overflow: hidden;
  padding: 0;
  cursor: pointer;
  img {
    width: 100%;
    height: 100%;
  }

  ${breakpoint.md`
    border-width: 6px;
    width: 157px;
    height: 157px;
  `}
`

export function Map({
  lng = 125.3253,
  lat = -17.6432,
  zoom = 7,
  bunubaOverlay = true,
  pin = false,
}) {
  const [modalOpen, setModalOpen] = useState(false)
  const { generateStaticMap } = useMapbox({
    center: [lng, lat],
    zoom,
    bunubaOverlay,
    pin,
  })

  return (
    <>
      <Head>
        <link
          href="https://api.tiles.mapbox.com/mapbox-gl-js/v2.1.1/mapbox-gl.css"
          rel="stylesheet"
          key="mapbox-css"
        />
      </Head>
      <MapLauncher onClick={() => setModalOpen(true)}>
        <picture>
          <source
            srcSet={generateStaticMap({
              width: 157,
              height: 157,
              zoom: 4,
              retina: true,
              attribution: false,
              // pin: false,
            })}
            media="(-webkit-min-device-pixel-ratio: 2) or (min-resolution: 2x)"
          />
          <img
            src={generateStaticMap({
              width: 157,
              height: 157,
              zoom: 4,
              attribution: false,
              // pin: false,
            })}
            alt="Bunuba Country Map (data © Mapbox, © OpenStreetMap)"
          />
        </picture>
      </MapLauncher>
      {modalOpen && (
        <MapModal
          modalOpen={modalOpen}
          setModalOpen={setModalOpen}
          bunubaOverlay={bunubaOverlay}
          pin={pin}
          lat={lat}
          lng={lng}
        />
      )}
    </>
  )
}

export default Map
